import React, { useEffect, useReducer } from "react";

import PanelReadOnly from "./components/panel-read-only";
import Tabs from "../../../tabs";

import { reducer, initialState } from "./reducers";

import "./nutrition.scss";

const NutritionReadOnly = (props) => {
    const readOnly = true;
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (!props.value || !props.value.panels) {
            return;
        }

        dispatch({ type: "SAVE_PANELS", panels: props.value.panels || [], isDirty: false });
    }, []);

    const changeTab = (tabIndex) => {
        dispatch({ type: "SET_PANEL_INDEX", selectedPanel: tabIndex });
    };

    const panelHtml =
        state.panels.length > 0 ? (
            <PanelReadOnly
                key={`panel_${state.selectedPanel}`}
                panel={state.panels[state.selectedPanel]}
                selectedIndex={state.selectedPanel}
                showDescription={props.showDescription}
                isCodingQA={props.isCodingQA}
            />
        ) : (
            <h3>No data to display</h3>
        );

    return (
        <div className="container">
            <Tabs
                tabs={state.panels}
                reportSelectedTab={changeTab}
                selectedTab={state.selectedPanel}
                readOnly={readOnly}
            />
            {panelHtml}
        </div>
    );
};

export default NutritionReadOnly;
